import ApiClient from "../api/ApiClient"
import { watch, provide, ref } from "vue"

export async function getCurrentUser() {
  try {
    const storedUser = localStorage.getItem("carl-user")
    if (storedUser !== null) {
      const user = JSON.parse(storedUser)
      const { data: currentUser } = await ApiClient.get(`/user/${user.id}`)
      return currentUser
    }
    return null
  } catch (error) {
    console.error(error)
    return null
  }
}

export default function useCurrentUser(authenticated) {
  const user = ref(null)
  /* provide as a convenience for some deeply nested components */
  provide("user", user)

  const setUser = async () => {
    /* First time authentication status is not set yet */
    if (authenticated.value === null) return
    if (!authenticated.value) {
      user.value = null
    /* Condition occurs when reloading the webpage while a user is authenticated */
    } else if (authenticated.value && user.value === null) {
      user.value = await getCurrentUser()
    }
  }

  /* Update value of "user" whenever value of "authenticated" changes */
  watch(authenticated, setUser)

  return { user }
}
